import { Container } from '../../odie';
import { IScreen } from '../../odie/plugins/nav/IScreen';
import appConfig from '../../defs/appConfig';

/*
    basic app screen
*/
export class BasicScreen implements IScreen {
  // fields
  //-------------------------------------------------------------------------
  // scene
  private readonly _root: Container;
  private readonly _view = new Container();

  // properties
  //-------------------------------------------------------------------------
  public get view(): Container {
    return this._view;
  }

  public get root(): Container {
    return this._root;
  }

  public get bounds(): Container {
    return this._root;
  }

  // init
  //-------------------------------------------------------------------------
  constructor() {
    const { width, height } = appConfig.size;

    // create root container
    const root = (this._root = new Container());
    root.width = width;
    root.height = height;

    // spawn
    this._view.addChild(root);
  }

  // api
  //-------------------------------------------------------------------------
  protected emptyRoot() {
    // remove root children
    this._root.removeChildren();
  }

  // impl
  //-------------------------------------------------------------------------
  public resize(width: number, height: number): void {
    const root = this._root;
    const appSize = appConfig.size;

    // scale to fit
    if (appSize.width / appSize.height > width / height) {
      root.scaleX = root.scaleY = width / appSize.width;
    } else {
      root.scaleX = root.scaleY = height / appSize.height;
    }

    // position to center
    root.x = (width - appSize.width * root.scaleX) / 2;
    root.y = (height - appSize.height * root.scaleY) / 2;
  }
}
